import React from 'react';
import styled from 'styled-components';

const StyledBackground = styled.div`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: url(/images/background_mobian.jpg) no-repeat center bottom fixed;
    background-size: cover;
    z-index: -1;
`;

const LoginBackground = () => {
    return <StyledBackground />;
};

export default LoginBackground;


// WEBPACK FOOTER //
// ./src/components/layout/Layout/LoginBackground.js